import { BROADCAST_CHANNELS, NOTIFICATION_TYPES } from '../config';

export default {
  beforeCreate() {
    this.$broadcastClient.private(BROADCAST_CHANNELS.CHANNEL_ALL).listen(NOTIFICATION_TYPES.NOTIFICATION_ADD, (event) => {
      if (event?.notification) {
        this.setNewNotification(event.notification);
      }
    });

    this.$broadcastClient.private(BROADCAST_CHANNELS.MAIN_CLIENTS).listen(NOTIFICATION_TYPES.NOTIFICATION_ADD, (event) => {
      if (event?.notification) {
        this.setNewNotification(event.notification);
      }
    });

    this.$broadcastClient.private(BROADCAST_CHANNELS.CHILD_CLIENTS).listen(NOTIFICATION_TYPES.NOTIFICATION_ADD, (event) => {
      if (event?.notification) {
        this.setNewNotification(event.notification);
      }
    });

    this.$broadcastClient.private(BROADCAST_CHANNELS.INDIVIDUAL_CLIENTS).listen(NOTIFICATION_TYPES.NOTIFICATION_ADD, (event) => {
      if (event?.notification) {
        this.setNewNotification(event.notification);
      }
    });

    this.$broadcastClient.private(BROADCAST_CHANNELS.ENTREPRENEUR_CLIENTS).listen(NOTIFICATION_TYPES.NOTIFICATION_ADD, (event) => {
      if (event?.notification) {
        this.setNewNotification(event.notification);
      }
    });

    this.$broadcastClient.private(BROADCAST_CHANNELS.LLC_CLIENTS).listen(NOTIFICATION_TYPES.NOTIFICATION_ADD, (event) => {
      if (event?.notification) {
        this.setNewNotification(event.notification);
      }
    });
  },
  beforeDestroy() {
    this.$broadcastClient.leaveChannel(BROADCAST_CHANNELS.CHANNEL_ALL);
    this.$broadcastClient.leaveChannel(BROADCAST_CHANNELS.MAIN_CLIENTS);
    this.$broadcastClient.leaveChannel(BROADCAST_CHANNELS.CHILD_CLIENTS);
    this.$broadcastClient.leaveChannel(BROADCAST_CHANNELS.INDIVIDUAL_CLIENTS);
    this.$broadcastClient.leaveChannel(BROADCAST_CHANNELS.ENTREPRENEUR_CLIENTS);
    this.$broadcastClient.leaveChannel(BROADCAST_CHANNELS.LLC_CLIENTS);
  },
};
